// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bej_a bhj_bj"};